const apiUrl = process.env.REACT_APP_API_URL;

export const serviceAddItem = async(obj) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/items/additem`;       
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify(obj)
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}




export const serviceUpdateItem = async(obj) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/items/updateItem`;       
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify(obj)
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}
